import React, { useState } from "react";

const Login = () => {
  const [auth, setAuth] = useState({
    username: "",
    password: "",
  });

  const handleSubmite = async (e) => {
    e.preventDefault();

    // axios({
    //   method: "POST",
    //   headers: { "Content-Type": "multipart/form-data" },
    //   url: "http://moviesapi.ir/oauth/token",
    //   data: {},
    // })
    //   .then((response) => {
    //     if (response.data.access_token) {
    //       localStorage.setItem(
    //         "token",
    //         JSON.stringify(response.data.access_token)
    //       );
    //     }
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  const changeHandler = (e) => {
    try {
      setAuth({ ...auth, [e.target.name]: e.target.value });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="px-4 lg:px-24 flex items-center justify-center py-16">
        <div className="border rounded-xl p-4 px-8 pt-6 pb-8 mb-4">
          <div className="mb-4">
            <label
              className="block text-gray-400 text-sm font-bold mb-2"
              htmlFor="username"
            >
              Username
            </label>
            <input
              className="appearance-none border rounded-lg w-[300px] py-2 px-3 text-grey-darker"
              id="username"
              name="username"
              value={auth.username}
              onChange={changeHandler}
              type="text"
              placeholder="Username"
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-grey-darker text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              className="appearance-none border border-red rounded-lg w-[300px] py-2 px-3 text-grey-darker mb-3"
              id="password"
              name="password"
              value={auth.password}
              onChange={changeHandler}
              type="password"
              placeholder="******************"
            />
            <p className="text-red text-xs italic">Please choose a password.</p>
          </div>
          <div className="flex  w-[300px] items-center justify-between">
            <button
              onClick={handleSubmite}
              className="flex space-x-3 transition-all duration-300 ease-in-out bg-sky-500 text-white hover:bg-sky-600 h-14 px-6 items-center justify-center rounded-xl"
              type="button"
            >
              Sign In
            </button>
            <a
              className="inline-block align-baseline font-bold text-sm text-blue hover:text-blue-600"
              href="/"
            >
              Forgot Password?
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
